var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuItemApplicationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    viewBox: "0 0 32 32",
    "data-name": "Layer 1",
    id: "Layer_1",
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 12,
    x: 10,
    y: 29
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 12,
    x: 10,
    y: 2
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 4,
    x: 9,
    y: 5
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 4,
    x: 9,
    y: 9
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 10,
    x: 13,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 3,
    x: 9,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 10,
    x: 13,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 3,
    x: 9,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 10,
    x: 13,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 3,
    x: 9,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 10,
    x: 13,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 3,
    x: 9,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 10,
    x: 13,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 3,
    x: 9,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    transform: "translate(9.5 41.5) rotate(-90)",
    width: 20,
    x: 15.5,
    y: 15.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,2V3h2a1,1,0,0,1,1,1V6h1V4a2,2,0,0,0-2-2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    transform: "translate(-9.5 22.5) rotate(-90)",
    width: 20,
    x: -3.5,
    y: 15.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,2V3H8A1,1,0,0,0,7,4V6H6V4A2,2,0,0,1,8,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,30V29h2a1,1,0,0,0,1-1V26h1v2a2,2,0,0,1-2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,30V29H8a1,1,0,0,1-1-1V26H6v2a2,2,0,0,0,2,2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 5,
    width: 1,
    x: 9,
    y: 5
  }), /*#__PURE__*/React.createElement("rect", {
    height: 5,
    width: 1,
    x: 12,
    y: 5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuItemApplicationIcon);
export default __webpack_public_path__ + "static/media/menu-item-application-icon.6f4e33340f79216d0ddf27af29b64b5a.svg";
export { ForwardRef as ReactComponent };